import React from 'react';
import properties from '../../constants/Properties';
import { connect } from 'react-redux';
import { SlideDurationSlider } from '../menus/SlideDurationSlider';
import configuration from '../../constants/Configuration';
import mouseUtils from '../../components/utils/MouseUtils';
import videoUtils from '../../components/utils/VideoUtils';
import hoverManager from '../utils/HoverManager';
import locales from "../../locales/LocalesManager";

const VolumeBarContent = React.createClass({
    getInitialState() {
        return {
            isVolumeDownOver: false,
            isVolumeUpOver: false,
            currentVolume: videoUtils.currentVideoVolume
        };
    },
    onVolumeDownMouseIn() {
        hoverManager.show(this.refs.minVolume, 'videoMinVolume');

        this.setState({
            isVolumeDownOver: true
        });
    },
    onVolumeDownMouseOut() {
        hoverManager.hide();

        this.setState({
            isVolumeDownOver: false
        });
    },
    onVolumeDownClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.setState({
            currentVolume: 0
        });

        videoUtils.currentVideoVolume = 0;
    },
    onVolumeUpMouseIn() {
        hoverManager.show(this.refs.maxVolume, 'videoMaxVolume');

        this.setState({
            isVolumeUpOver: true
        });
    },
    onVolumeUpMouseOut() {
        hoverManager.hide();

        this.setState({
            isVolumeUpOver: false
        });
    },
    onVolumeUpClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.setState({
            currentVolume: 1
        });

        videoUtils.currentVideoVolume = 1.0;
    },
    render() {
        if (!this.props.showVideoEditor)
            return (<div/>);

        const width = this.props.windowWidth - this.props.accordionWidth;
        const height = properties.PREVIEW_HEIGHT;

        const menuStyle = {
            position: 'absolute',
            backgroundColor: properties.RECORDING_MENU_BACKGROUND,
            width: width,
            height: height,
            top: this.props.windowHeight - height - this.props.scaleProperties.topY,
            left: - (width - configuration.CANVAS_WIDTH * this.props.scaleProperties.scale) / 2,
            cursor: 'default',
            userSelect: 'none',
            userDrag: 'none',
            WebkitUserSelect: 'none'
        };

        var iconColor;
        var sliderWidth = 190;
        const sliderHolderStyle = {
            position: 'absolute',
            width: sliderWidth,
            height: height,
            top: 0,
            left: width - sliderWidth
        };

        var sliderProperties = {};
        sliderProperties.topPosition = (height - properties.RECORDING_BUTTON_HEIGHT) / 2;
        sliderProperties.leftPosition = 35;
        sliderProperties.width = properties.RECORGING_SLIDER_WIDTH;
        sliderProperties.height = properties.RECORDING_BUTTON_HEIGHT;
        sliderProperties.thumbSize = properties.STYLING_THUMB_SIZE - 2;
        sliderProperties.start = 0;
        sliderProperties.end = 10;
        sliderProperties.step = 1;
        sliderProperties.dispatch = this.props.dispatch;
        sliderProperties.isVideo = true;
        sliderProperties.currentValue = videoUtils.currentVideoVolume * 10;

        if (this.state.isVolumeDownOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            iconColor = '#272727';

        const volumeIconDownButton = {
            position: 'absolute',
            width: 32,
            height: 32,
            left: 0,
            top: 7,
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            borderStyle: 'none',
            background: 'none'
        };

        const volumeIconDown = {
            position: 'absolute',
            left: 7,
            top: 0,
            color: iconColor
        };

        if (this.state.isVolumeUpOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            iconColor = '#272727';

        const volumeIconUpButton = {
            position: 'absolute',
            width: 32,
            height: 32,
            left: 35 + properties.RECORGING_SLIDER_WIDTH + 10,
            top: 7,
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            borderStyle: 'none',
            background: 'none'
        };

        const volumeIconUp = {
            position: 'absolute',
            left: 1,
            top: 0,
            color: iconColor
        };

        return (
            <div style={menuStyle}>
                <div style={sliderHolderStyle}>
                    <button aria-label={locales.getCaption('videoMinVolume', 'hover')} style={volumeIconDownButton} onMouseOver={this.onVolumeDownMouseIn} onMouseOut={this.onVolumeDownMouseOut} onClick={this.onVolumeDownClick} onTouchEnd={this.onVolumeDownClick}>
                        <i ref='minVolume' style={volumeIconDown} className='fa fa-volume-off fa-2x'></i>
                    </button>

                    <SlideDurationSlider properties={sliderProperties} refreshVideoEditor={this.props.refreshVideoEditor}/>

                    <button aria-label={locales.getCaption('videoMaxVolume', 'hover')} style={volumeIconUpButton} onMouseOver={this.onVolumeUpMouseIn} onMouseOut={this.onVolumeUpMouseOut} onClick={this.onVolumeUpClick} onTouchEnd={this.onVolumeUpClick}>
                        <i ref='maxVolume' style={volumeIconUp} className='fa fa-volume-up fa-2x'></i>
                    </button>
                </div>
            </div>
        );
    }
});

function mapStateToProps(state) {
    var showVideoEditor = state.menu.showVideoEditor;

    if (!showVideoEditor)
        showVideoEditor = false;

    return {
        showVideoEditor
    };
}

export const VolumeBar = connect(mapStateToProps)(VolumeBarContent);



/** WEBPACK FOOTER **
 ** ./src/components/videoEditor/VolumeBar.js
 **/